import { useLang } from "@/contexts/LanguageContext";

export default function LanguageToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="segment-pill" role="group" aria-label="Language">
      <button
        data-testid="lang-toggle-en"
        data-active={lang === "en"}
        onClick={() => setLang("en")}
        className="segment-btn"
      >
        EN
      </button>
      <button
        data-testid="lang-toggle-es"
        data-active={lang === "es"}
        onClick={() => setLang("es")}
        className="segment-btn"
      >
        ES
      </button>
    </div>
  );
}
